import React from 'react';
import { useInput, useTranslate } from 'react-admin';
import { NumericFormat } from 'react-number-format';
import PropTypes from 'prop-types';
import ResettableTextField from '../ra/inputs/ResettableTextField';

const FloatNumberInput = ({ source, validate, label, isRequired, ...props }) => {
  const t = useTranslate();

  const {
    meta: { error, submitError, touched },
    input: { onChange, value },
  } = useInput({
    source,
    validate,
  });

  return (
    <NumericFormat
      customInput={ResettableTextField}
      source={source}
      variant="outlined"
      label={isRequired ? `${t(label)} *` : t(label)}
      resettable
      value={value}
      decimalScale={2}
      onValueChange={(v) => {
        // value without prefix
        onChange(v?.value ? parseFloat(v?.value) : v?.value);
      }}
      onReset={() => {
        onChange();
      }}
      error={!!(touched && (error || submitError))}
      helperText={touched && (error || submitError) ? error || submitError : ' '}
      {...props}
    />
  );
};

FloatNumberInput.propTypes = {
  source: PropTypes.string.isRequired,
  validate: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
  label: PropTypes.string,
  isRequired: PropTypes.bool,
};

export default FloatNumberInput;
